// "Getting Started with Companion" blog hero — back link, eyebrow, title, deck,
// and the Scribenote Team author row.
import { Link } from "react-router";

export function GettingStartedHero() {
  return (
    <section className="px-[clamp(24px,5vw,80px)] pt-12 pb-14">
      <div className="mx-auto max-w-[760px]">
        <Link
          to="/"
          className="mb-4 inline-flex items-center gap-1.5 text-sm font-medium text-secondary no-underline hover:text-indigo-600"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M19 12H5M12 19l-7-7 7-7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back
        </Link>

        <div className="mb-6 flex flex-wrap gap-2">
          <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.04em] text-indigo-700">
            From the blog
          </div>
        </div>

        <h1 className="font-companion mb-6 text-[clamp(40px,5.5vw,64px)] font-bold leading-[1.05] tracking-[-0.03em] text-primary [text-wrap:balance]">
          Getting Started with Companion.
        </h1>

        <p className="mb-9 font-companion text-[22px] leading-[1.5] text-secondary [text-wrap:pretty]">
          Your AI assistant inside of Scribenote. It amplifies your ability as a
          veterinary professional — handling documentation, research, client
          communication, and more — so you can stay focused on the patient in
          front of you.
        </p>

        <div className="flex items-center gap-3.5 border-t border-grindigo-100 pt-6">
          <div className="font-companion grid h-12 w-12 shrink-0 place-items-center rounded-full bg-[linear-gradient(135deg,#6366F1_0%,#818CF8_100%)] text-[15px] font-bold tracking-[0.02em] text-white shadow-[0_4px_12px_-4px_rgba(99,102,241,0.5)]">
            SN
          </div>
          <div>
            <div className="text-[15px] font-semibold text-primary">
              The Scribenote Team
            </div>
            <div className="text-[13px] text-secondary">April 2026</div>
          </div>
        </div>
      </div>
    </section>
  );
}
